import { isMultiTenant } from "@/Configs/config";
import { useSelectedSite } from "@/api/hooks/useSelectedSite";
import { Card, CardComponentVariant } from "@/components/pageCards/card";
import { useTrans } from "@/translations";

import { FC, useMemo } from "react";
import { Link } from "react-router-dom";

export const PreFilteringCard: FC<{
  entityKey: string;
  eventFilter?: string;
  customersFilter?: string;
}> = ({ entityKey, eventFilter, customersFilter }) => {
  const { t } = useTrans();
  const entity = t(`entities:${entityKey}`);

  const { selectedSite } = useSelectedSite();

  const sitePath = useMemo(() => {
    let path = "";

    if (isMultiTenant && selectedSite?.siteName) {
      path = `/${selectedSite.siteName}`;
    }

    return path;
  }, [selectedSite]);

  return (
    <Card
      title={"drawerLabels:preFiltering"}
      variant={CardComponentVariant.DRAWER}
    >
      <p className="text black font-dm-sans mb-4 text-sm">
        {t("hints:goToEntityPrefilteredEvents", {
          entity: entity.toLowerCase(),
        })}
      </p>
      {eventFilter && (
        <div className="flex items-center">
          <Link
            to={{
              pathname: `${sitePath}/events`,
              search: `?filters=${eventFilter}`,
            }}
            className="font-dm-sans w-1/2 pr-9 text-base font-medium underline"
          >
            {t("actions:seeEntityEvents", {
              entity: entity.toLowerCase(),
            })}
          </Link>
          <p className="font-dm-sans text-sm text-black">
            {t("hints:entityLatestEvents", { entity: entity.toLowerCase() })}
          </p>
        </div>
      )}
      {customersFilter && (
        <div className="mt-2 flex items-center">
          <Link
            to={{
              pathname: `${sitePath}/customer/manage`,
              search: `?filters=${eventFilter}`,
            }}
            className="font-dm-sans w-1/2 pr-9 text-base font-medium underline"
          >
            {t("actions:seeEntityCustomers", {
              entity: entity.toLowerCase(),
            })}
          </Link>
          <p className="font-dm-sans text-sm text-black">
            {t("hints:entityCustomers", { entity: entity.toLowerCase() })}
          </p>
        </div>
      )}
    </Card>
  );
};
